import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    paddingTop: "0px !important",
    "@media (orientation: landscape)": {
      height: "100% !important",
    },
  },
  content: {
    textAlign: "center",
    display: "grid",
    gap: theme.spacing.space8,
  },
  label: {},
  addIcon: {
    fontSize: 15,
  },
  download: {},
  image: {
    verticalAlign: "middle",
    paddingBottom: 2,
  },
}));
